import { render, staticRenderFns } from "./Release520Update.vue?vue&type=template&id=9c0ffbec"
import script from "./Release520Update.vue?vue&type=script&lang=js"
export * from "./Release520Update.vue?vue&type=script&lang=js"
import style0 from "./Release520Update.vue?vue&type=style&index=0&id=9c0ffbec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports